// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__11Hou","label":"Category_label__TUFzZ","content":"Category_content__2xGnm","header":"Category_header__Sc88N","location":"Category_location__10mGi"};